import { useAppDispatch, useAppSelector } from '@hooks/useRedux';
import { selectCurrentUser } from '@store/auth/authSelectors';
import {
  fetchBilling,
  fetchInvoices,
  // selectTrialDaysRemaining as selectBillingDaysRemaining,
  selectSubscription as selectBillingSubscription,
  selectInvoices,
} from '@store/billing';
import { openQuickActionsModal } from '@store/runningOrder';
import React, { useEffect } from 'react';
import { Button } from '../common';

// const formatDaysLabel = (daysLeft: number): string => {
//   if (daysLeft < 30) return `${daysLeft.toLocaleString()} days left`;
//   return `${Math.max(1, Math.ceil(daysLeft / 30)).toLocaleString()} months left`;
// };

export const BillingDaysCounter: React.FC = () => {
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector(selectCurrentUser);
  const billingSubscription = useAppSelector(selectBillingSubscription);
  const invoices = useAppSelector(selectInvoices);
  // const billingDaysLeft = useAppSelector(selectBillingDaysRemaining);
  // const authLabel = useAppSelector(selectAuthBillingTimeLeftLabel);

  const companyId = currentUser?.company?.id;

  // Fetch billing + invoices so current_period_end is always fresh.
  // Invoices provide a fallback period_end when current_period_end is missing
  // (common when Stripe webhook hasn't synced yet).
  useEffect(() => {
    if (!companyId) return;
    if (!billingSubscription) dispatch(fetchBilling(companyId));
    if (invoices.length === 0) dispatch(fetchInvoices(companyId));
  }, [dispatch, companyId, billingSubscription, invoices.length]);

  // Prefer billing state (direct from billing_records, up-to-date with Stripe).
  // Fall back to auth state while billing data is still loading.
  // const label = billingSubscription
  //   ? formatDaysLabel(billingDaysLeft)
  //   : authLabel;

  return (
    <div className="flex h-full items-center justify-center w-full">
      <Button
        variant="outline"
        size="sm"
        onClick={() => dispatch(openQuickActionsModal())}
        className="border border-transparent w-full"
      >
        Quick Actions
      </Button>
    </div>
  );
};
